<script lang="ts">
  import type {
    WorkOrderAssignmentRequesterHints,
    WorkOrderAssignmentRow,
  } from "../../../../contract"
  import ContextTags from "../../../../_shared/_modules/context-tags"

  let { row }: { row: WorkOrderAssignmentRow } = $props()

  const requesterHints = $derived<WorkOrderAssignmentRequesterHints>(
    row.requesterHints ?? {
      tags: [],
      notes: [],
    },
  )
</script>

<div class="requester-hints-cell" class:disabled={row.disabled}>
  <ContextTags tags={requesterHints.tags} />
</div>

<style lang="less">
  .requester-hints-cell {
    display: grid;
    gap: 0.36rem;
    max-width: 320px;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    color: var(--text-invers-100);
  }

  .requester-hints-cell.disabled {
    opacity: 0.62;
  }
</style>
